/**
 * Информация о токене.
 */
export class TokenInformation {
    /**
     * Access token.
     */
    accessToken: string;

    /**
     * Refresh token.
     */
    refreshToken: string;

    /**
     * тип токена.
     */
    tokenType: string;

    /**
     * Время жизни access токена.
     */
    expiresIn: number;

    public static deserialize(data: any): TokenInformation {
        const tokenInformation = new TokenInformation();
        tokenInformation.accessToken = data.access_token;
        tokenInformation.refreshToken = data.refresh_token;
        tokenInformation.tokenType = data.token_type;
        tokenInformation.expiresIn = +data.expires_in;
        return tokenInformation;
    }
}
